import { ehProblemDetails, type ProblemDetails } from "@base/contracts";

/**
 * Erro da API do lado do front, com o Problem Details preservado.
 *
 * O ganho concreto: a tela consegue mostrar mensagem por campo (`errors`) e o
 * `requestId` para o usuario citar no suporte, em vez de exibir
 * "Erro inesperado" e obrigar alguem a caçar no log.
 */
export class ErroDaApi extends Error {
  constructor(
    readonly status: number,
    readonly problema: ProblemDetails | null,
    mensagem: string,
  ) {
    super(mensagem);
    this.name = "ErroDaApi";
  }

  get requestId(): string | null {
    return this.problema?.requestId ?? null;
  }

  /** Erros por campo, no formato que o formulario consome. */
  get campos(): Readonly<Record<string, readonly string[]>> {
    return this.problema?.errors ?? {};
  }

  get ehNaoAutorizado(): boolean {
    return this.status === 401;
  }

  get ehProibido(): boolean {
    return this.status === 403;
  }

  get ehNaoEncontrado(): boolean {
    return this.status === 404;
  }

  /** Vale repetir? Falha de rede e 5xx sim; erro de validacao nao. */
  get valeRepetir(): boolean {
    return this.status === 0 || this.status >= 500 || this.status === 429;
  }

  static deResposta(status: number, corpo: unknown): ErroDaApi {
    if (ehProblemDetails(corpo)) {
      return new ErroDaApi(status, corpo, corpo.detail || corpo.title);
    }
    return new ErroDaApi(
      status,
      null,
      `A API respondeu ${status} em um formato inesperado.`,
    );
  }

  static deRede(causa: unknown): ErroDaApi {
    return new ErroDaApi(
      0,
      null,
      causa instanceof Error && causa.message
        ? `Nao foi possivel falar com a API: ${causa.message}`
        : "Nao foi possivel falar com a API.",
    );
  }
}
